<main class="maintenance" role="status" aria-live="polite">
	<div class="maintenance__orb maintenance__orb--primary"></div>
	<div class="maintenance__orb maintenance__orb--accent"></div>

	<section class="maintenance__card">
		<img
			class="maintenance__logo"
			src="assets/images/logo_sanus.svg"
			alt="Sanus"
		/>

		<span class="maintenance__badge">Em manutenção</span>

		<h1 class="maintenance__title">O site está em manutenção</h1>

		<p class="maintenance__message">
			Estamos realizando melhorias para oferecer uma experiência ainda melhor.
			Em breve retornaremos.
		</p>

		<div class="maintenance__dots" aria-hidden="true">
			<span class="maintenance__dot"></span>
			<span class="maintenance__dot"></span>
			<span class="maintenance__dot"></span>
		</div>
	</section>

	<p class="maintenance__footer">Obrigado pela compreensão</p>
</main>
